/* global axios */
import ApiClient from './ApiClient';

class ConversationWorkflowsAPI extends ApiClient {
  constructor() {
    super('conversation_workflows', { accountScoped: true });
  }

  executions(workflowId, { page = 1, perPage } = {}) {
    const params = { page };
    if (perPage) params.per_page = perPage;
    return axios.get(`${this.url}/${workflowId}/executions`, { params });
  }

  executionShow(workflowId, executionId) {
    return axios.get(`${this.url}/${workflowId}/executions/${executionId}`);
  }

  executionDelete(workflowId, executionId) {
    return axios.delete(`${this.url}/${workflowId}/executions/${executionId}`);
  }
}

export default new ConversationWorkflowsAPI();
